
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.75 5c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v14c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25V5zM6 2.25A2.75 2.75 0 003.25 5v14A2.75 2.75 0 006 21.75h12A2.75 2.75 0 0020.75 19V5A2.75 2.75 0 0018 2.25H6zM8.256 6c-.476 0-.956.1-1.353.313-.355.19-.895.621-.895 1.354v.666c0 .733.54 1.164.895 1.354.397.212.877.313 1.353.313h7.488c.476 0 .956-.1 1.353-.313.355-.19.895-.621.895-1.354v-.666c0-.733-.54-1.164-.895-1.354C16.7 6.101 16.22 6 15.744 6H8.256zM8 13.25a.75.75 0 01.75.75v.01a.75.75 0 11-1.5 0V14a.75.75 0 01.75-.75zm4.75.75a.75.75 0 00-1.5 0v.01a.75.75 0 101.5 0V14zm3.25-.75a.75.75 0 01.75.75v.01a.75.75 0 11-1.5 0V14a.75.75 0 01.75-.75zM8.75 17a.75.75 0 00-1.5 0v.01a.75.75 0 101.5 0V17zm3.25-.75a.75.75 0 01.75.75v.01a.75.75 0 11-1.5 0V17a.75.75 0 01.75-.75zm4.75.75a.75.75 0 00-1.5 0v.01a.75.75 0 101.5 0V17z"}})])
          )
        }
      }
    